export default __webpack_public_path__ + "static/media/IMG_5988 copie.777f9903.jpg";